import { useState } from 'react';
import { predefinedTemplates } from 'constants/entities';
import { CREATE_QUICK_ENTITY_MODAL } from 'constants/modals';
import { useAppDispatch, useAppSelector } from 'hooks';
import { commonActions } from 'store/slices/mapV2/mapReducer/toolsReducer/commonSlice';
import { commonToolSelector } from 'store/slices/mapV2/mapReducer/toolsReducer/commonSlice/selectors';
import { QuickEntityCreateTool } from 'store/slices/mapV2/mapReducer/toolsReducer/commonSlice/types';
import { stateActions } from 'store/slices/mapV2/mapReducer/toolsReducer/stateSlice';
import { createQuickMapEntityThunk } from 'store/slices/mapV2/tabsReducer/layersReducer/mapEntitiesSlice/actions';
import { predefinedTemplateSelector } from 'store/slices/mapV2/tabsReducer/layersReducer/mapEntitiesSlice/selectors';
import { modalsActions } from 'store/slices/service/modalsSlice';
import { MapDrawModes } from 'types';

import { Button, Modal, Select } from 'components/ui';

export const CreateQuickEntityModal = () => {
  const commonTool = useAppSelector(
    commonToolSelector
  ) as QuickEntityCreateTool;

  const mapLayerTemplate = useAppSelector((state) =>
    predefinedTemplateSelector(state, predefinedTemplates.MAP_LAYER)
  );
  const mapObjectTemplate = useAppSelector((state) =>
    predefinedTemplateSelector(state, predefinedTemplates.MAP_OBJECT)
  );

  const [parentEntityId, setParentEntityId] = useState(0);

  const dispatch = useAppDispatch();

  const handleClose = () =>
    dispatch(modalsActions.removeModal(CREATE_QUICK_ENTITY_MODAL));

  const handleCancel = () => {
    dispatch(stateActions.setInteractionMode(MapDrawModes.simple_select));
    dispatch(commonActions.setCommonTool(null));
    handleClose();
  };

  const handleAccept = async () => {
    if (commonTool.value.entity && mapLayerTemplate && mapObjectTemplate) {
      const upsertEntityParams = {
        ...commonTool.value.entity,
        parentEntityID: parentEntityId,
        ...{
          ...(commonTool.value.secondaryParentName && {
            autoFolder: {
              title: commonTool.value.secondaryParentName,
              templateID: mapLayerTemplate.template.id,
            },
          }),
        },
      };

      commonTool.value.changePrimalParentId(parentEntityId, commonTool);

      await dispatch(createQuickMapEntityThunk(upsertEntityParams));
    }

    handleClose();
  };

  return (
    <Modal onClose={handleClose} width={460} keyboard isBlurred>
      <div className="flex justify-center flex-col items-center gap-6 w-full px-[74px] py-10 bg-dark border border-solid border-tpg_light rounded-[10px]">
        <div className="flex flex-col gap-3 text-center">
          <span className="tpg-h4">Не удалось создать объект</span>
          <span className="tpg-b2">
            Выберите папку, в которой будут создаваться объекты по умолчанию
          </span>
        </div>
        <Select
          value={parentEntityId}
          options={commonTool.value.primalParentOptions}
          placeholder="Выбрать папку"
          onSelect={setParentEntityId}
          theme="light"
          withSearch
          withEmpty={false}
          isExpandable
        />
        <div className="flex gap-2 w-full">
          <Button
            title="Отменить"
            onClick={handleCancel}
            className="w-full hover:bg-bright bg-inherit border border-solid border-dark_product"
          />
          <Button title="Создать" onClick={handleAccept} className="w-full" />
        </div>
      </div>
    </Modal>
  );
};
